import { render, staticRenderFns } from "./addTeacher.vue?vue&type=template&id=9237399e&scoped=true&"
import script from "./addTeacher.vue?vue&type=script&lang=js&"
export * from "./addTeacher.vue?vue&type=script&lang=js&"
import style0 from "./addTeacher.vue?vue&type=style&index=0&id=9237399e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9237399e",
  null
  
)

export default component.exports